import type { FetchUserData } from "@assetwatch/auth";
import { post } from "aws-amplify/api";

type CurrentUserInfo = {
  email?: string;
  preferences?: unknown[];
  roles?: unknown;
};

async function getCurrentModalityUserInfo() {
  const { body } = await post({
    apiName: "apiVeroUser",
    path: "/list",
    options: {
      body: {
        meth: "getCurrentUserInfo",
      },
    },
  }).response;

  return (await body.json()) as CurrentUserInfo;
}

export function getUserRoles(value: unknown) {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter((role): role is string => typeof role === "string");
}

export const fetchModalityUserData: FetchUserData = async ({ baseUser }) => {
  try {
    const userInfo = await getCurrentModalityUserInfo();

    return {
      email: userInfo.email ?? baseUser.email,
      preferences: Array.isArray(userInfo.preferences)
        ? userInfo.preferences
        : [],
      roles: getUserRoles(userInfo.roles),
    };
  } catch (error) {
    console.error("[modality.fetchModalityUserData]", error);

    return {
      email: baseUser.email,
      preferences: [],
      roles: [],
    };
  }
};
